import React from 'react'
import { Link } from 'react-router-dom'

const AddPlayer = () => {
    return (
        <>
            <div className="page-wrapper">
                <div className="page-content">
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Teams Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Add New Player</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="detail_top_pgg">
                        <Link to="/team-management-detail"><i className="bx bx-arrow-back" /><span>Back</span></Link>
                    </div>
                    <div className="add_info_wrpr">
                        <form>
                            <div className="card personal_d">
                                <div className="card-body">
                                    <h2>Player Info</h2>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">First Name</label>
                                            <input type="text" className="form-control" placeholder="First Name" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Last Name</label>
                                            <input type="text" className="form-control" placeholder="Last Name" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Date Of Birth</label>
                                            <input type="date" className="form-control" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Jersey Number</label>
                                            <input type="text" className="form-control" placeholder="Jersey Number" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Assign Team</label>
                                            <input type="text" className="form-control" placeholder="Assign Team" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Position</label>
                                            <input type="text" className="form-control" placeholder="Position" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card personal_d">
                                <div className="card-body">
                                    <h2>Parent/Guardian Info</h2>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Full Name</label>
                                            <input type="text" className="form-control" placeholder="Full Name" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Email Address</label>
                                            <input type="email" className="form-control" placeholder="Email Address" />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Phone Number</label>
                                            <input type="text" className="form-control" placeholder="Phone Number" />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Relationship</label>
                                            <input type="email" className="form-control" placeholder="Relationship" />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Emergency Contact Number</label>
                                            <input type="text" className="form-control" placeholder="Emergency Contact Number" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary ms-auto d-block mb-3">Add Player</button>
                        </form>
                    </div>
                </div>
            </div>

        </>
    )
}

export default AddPlayer